/**
 * Redacteaza tokenul de colaborator (o credentiala bearer, doar ca sta in path, nu in header)
 * oriunde ar putea aparea intr-un text - URL de telemetrie, mesaj de log.
 *
 * NU mai e literal identic cu `CollabTokenRedactor` din backend (fix round 2, E1): backendul vede
 * doar `/api/collab/<token>/...` (calea API), dar linkul public trimis colaboratorului e
 * `frontend.activitate.colaborator.url + "/" + token` -> `https://.../activitate/<token>`
 * (`CollaboratorLinkService.toDto`, backend). Cu `enableAutoRouteTracking: true`, pagina din
 * Task 14 trimite tokenul intreg spre Azure prin ruta asta, nu prin `/api/collab/`. De aceea
 * patternul de aici prinde AMBELE forme. Preview-ul (primele 8 caractere) ramane acelasi format
 * ca in backend, ca incidentele sa se coreleze intre cele doua parti - dar regexul nu se mai
 * poate "resincroniza" mecanic cu backendul fara sa reintroduca gaura de pe `/activitate/`.
 *
 * Nu ancorat pe inceput de sir: tokenul poate aparea in mijlocul unui URL complet
 * (`https://.../api/collab/<token>/files`, `https://.../activitate/<token>`) sau al unui mesaj
 * compus.
 */
const COLLAB_TOKEN = /(\/?(?:api\/collab|activitate)\/)([A-Za-z0-9_-]+)/g;

export function redactCollabToken(text: string): string {
    if (!text) return text;
    return text.replace(COLLAB_TOKEN, (_match, prefix: string, token: string) => {
        const preview = token.length > 8 ? token.slice(0, 8) : token;
        return `${prefix}{token:${preview}...}`;
    });
}
